import { createPanelController } from '../shared/ui-panel-base.js';
import { sendFeedback } from '../requests/clients.js';
import { closePanel } from '../shared/ui-panel-controller.js';

export const createFeedbackPanel = createPanelController('settings-feedback-create', {
  onOpen: () => {
    console.log('[FeedbackCreatePanel] Opening feedback panel');
    resetFeedbackForm();
  },
  onClose: () => {
    console.log('[FeedbackCreatePanel] Closing feedback panel');
  },
});

function resetFeedbackForm() {
  rating = 0;
  selectedType = 'rating';
  const rateButtons = document.querySelectorAll(".rate-btn");
  rateButtons.forEach(btn => btn.classList.remove("active"));
  document.getElementById('settings-feedback-details').value = '';
  const typeButtons = document.querySelectorAll(".type-btn");
  typeButtons.forEach(btn => btn.classList.remove("active"));
}

let rating = 0; // 0 = no rating, 1 = thumbs down, 2 = thumbs up
const rateButtons = document.querySelectorAll(".rate-btn");

rateButtons.forEach(button => {
  button.addEventListener("click", () => {
    rateButtons.forEach(btn => btn.classList.remove("active"));
    button.classList.add("active");
    rating = button.dataset.type;
  });
});

let selectedType = "rating"; // Default feedback type
const typeButtons = document.querySelectorAll(".type-btn");

const feedbackTemplates = {
  rating: "Just wanted to rate the app...",
  bug: "I encountered a bug when I tried to...",
  suggestion: "I have a suggestion to improve the app...",
  praise: "I just want to say I love this app...",
  question: "I have a question about...",
  other: "I have some other feedback..."
};

typeButtons.forEach(button => {
  button.addEventListener("click", () => {
    typeButtons.forEach(btn => btn.classList.remove("active"));
    button.classList.add("active");
    selectedType = button.dataset.type;
    const detailsTextarea = document.getElementById('settings-feedback-details');
    detailsTextarea.value = feedbackTemplates[selectedType];
    detailsTextarea.focus();
    // Move cursor to the end of the textarea
    detailsTextarea.setSelectionRange(detailsTextarea.value.length, detailsTextarea.value.length);
  });
});

document.getElementById('settings-submit-feedback-btn').addEventListener('click', async () => {
  const details = document.getElementById('settings-feedback-details').value.trim();

  if (!rating || !selectedType) {
    // Show an error message to the user
    alert('Please rate or (and) select a feedback type and provide details.');
    // console.warn('[FeedbackCreatePanel] Missing rate or feedback type');
    return;
  }

  console.log('[FeedbackCreatePanel] Sending feedback:', { rating, selectedType, details });
  const type = selectedType;
  await sendFeedback(rating, type, details);});

document.querySelector('#settings-feedback-create-sheet .back-btn')?.addEventListener('click', () => {
  resetFeedbackForm();
  console.log('[FeedbackCreatePanel] Back to settings from feedback create panel');
  closePanel('settings-feedback-create'); // Will automatically restore previous panel (e.g. settings)
});
